import { useTranslation } from "react-i18next";
import {
  enumremoteconnectionstatusToI18nKey,
  type EnumRemoteConnectionStatus,
} from "../../../generated/enums";

/**
 * Couleur par issue de connexion.
 *
 * `denied` en rouge : c'est le signal à repérer dans une liste (quelqu'un a tenté
 * d'accéder à un produit qui n'est pas le sien). `error` reste gris — c'est une panne
 * technique, pas un fait d'usage, et le colorer en rouge noierait les vrais refus.
 *
 * Palette réelle du projet : `secondary` #A9B54B, `tertiary` #293610. `bg-primary`
 * N'EXISTE PAS dans tailwind.config.js.
 */
const STATUS_CLASSES: Record<EnumRemoteConnectionStatus, string> = {
  granted: "bg-secondary text-white",
  denied: "bg-red-700 text-white",
  // `warning` (#FF9800) est la teinte d'alerte du projet. Attention : la palette Tailwind
  // par défaut n'est PAS chargée ici (pas de `amber-*`, pas de `bg-primary`) — une classe
  // inexistante ne produit aucune erreur, juste une pastille sans fond.
  not_found: "bg-warning text-default-text",
  unavailable: "bg-warning text-default-text",
  error: "bg-grey-medium text-white",
};

/**
 * Pastille de statut. Le libellé traduit est TOUJOURS présent : la couleur seule
 * n'est pas une information accessible (daltonisme, impression noir et blanc).
 */
export const RemoteConnectionStatusBadge = ({
  status,
}: {
  status: EnumRemoteConnectionStatus;
}) => {
  const { t } = useTranslation();
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium whitespace-nowrap ${STATUS_CLASSES[status]}`}
    >
      {t(enumremoteconnectionstatusToI18nKey[status])}
    </span>
  );
};
